import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CreditCard, ExternalLink, Sparkles } from "lucide-react";
import { listPublicPlans } from "@/lib/console-api";

export function BillingPage(): JSX.Element {
  // 향후 organizationId 기반 Subscription 조회로 확장. 지금은 공개 플랜만 표시.
  const plansQuery = useQuery({
    queryKey: ["pricing-plans-public"],
    queryFn: listPublicPlans,
  });
  const plans = plansQuery.data ?? [];

  return (
    <div className="space-y-6 p-8">
      <header>
        <p className="text-sm text-muted-foreground">결제</p>
        <h1 className="mt-1 text-2xl font-bold tracking-tight">결제 / 플랜</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          현재 사용 중인 플랜과 결제 정보를 확인합니다.
        </p>
      </header>

      <section className="rounded-lg border border-border bg-card p-6">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Sparkles className="h-4 w-4" /> 현재 플랜
        </div>
        <p className="mt-2 text-2xl font-bold tracking-tight">
          🎉 무료 베타
        </p>
        <p className="mt-1 text-sm text-muted-foreground">
          개인 / 팀 워크스페이스 모두 베타 기간 동안 무료로 사용할 수 있습니다.
          정식 출시 시 팀 플랜은 유료로 전환되며, 변경 전 미리 안내드립니다.
        </p>
      </section>

      <section className="rounded-lg border border-border bg-card p-6">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <CreditCard className="h-4 w-4" /> 결제 정보
        </div>
        <p className="mt-3 text-sm text-muted-foreground">
          정식 출시 후 카드 등록 / 영수증 / 청구 내역이 여기 표시됩니다.
          현재는 결제 정보가 필요 없습니다.
        </p>
      </section>

      {plans.length > 0 && (
        <section className="rounded-lg border border-border bg-card p-6">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="text-base font-semibold">제공 플랜</h2>
            <Link
              to="/pricing"
              className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
            >
              가격 페이지 <ExternalLink className="h-3 w-3" />
            </Link>
          </div>
          <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {plans.map((p) => (
              <li
                key={p.id}
                className="rounded-md border border-border p-4"
              >
                <p className="font-medium">{p.name}</p>
                <p className="mt-1 text-sm text-muted-foreground">
                  {p.priceCents === 0
                    ? "무료"
                    : `$${(p.priceCents / 100).toFixed(2)}${
                        p.isPerSeat ? "/좌석" : ""
                      }/${p.billingPeriod === "year" ? "년" : "월"}`}
                </p>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
